import React from 'react';
import Expand_down from '@tdcerhverv/parrotfish/icons/ExpandDown';
export const ExpandDownIcon = (React.createElement(Expand_down, { style: {
        fill: 'currentColor',
        width: '0.75em',
        height: '0.75em',
        display: 'inline-block',
        fontSize: 'inherit',
        flexShrink: 0,
    } }));
